import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
const b = new DocsBlockBuilder();
const id = "io.supernova.block.context-mcp";
const name = "MCP connection";
const icon = "https://cdn-assets.supernova.io/blocks/icons/context-mcp.svg";
const descriptionShort = "Show connection options for MCP server";
const docsUrl = "https://learn.supernova.io/latest/mcp-context-block";
const searchKeywords = ["context", "mcp", "ai", "cursor", "codex", "claude"];
const properties = {
    context: b.contextProperty({
        id: "context",
        name: "Context",
        options: {},
    }),
};
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.context],
});
const blockItem = b.singleVariantItem({
    properties: [properties.context],
    variant: defaultVariant,
});
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.other,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText: "Use MCP connection to help readers connect Supernova's MCP server to their AI tools.",
        documentationLink: docsUrl,
    }),
    appearance: {
        showBlockHeaderInEditor: false,
    },
});
export { block as ContextMcp };
